import { render, staticRenderFns } from "./OrganIcon.vue?vue&type=template&id=b347ea16"
import script from "./OrganIcon.vue?vue&type=script&lang=ts"
export * from "./OrganIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports